var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoAvm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 425.2 425.2"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E2001A",
  d: "m89.4 266.2 39.1-43.5v43.5h31.2V143L47.3 266.2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0089D1",
  d: "M202.2 144.3h-30v125.4l143.1-156.5h-42.7l-70.4 78.4z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M368.1 136.5 308 202.4v-64.5L162.2 297.3l42.4.1 73.3-81.2v65l57.8-63.9v48.9h32.4z"
})));
export default SvgLogoAvm;